import React from "react";
import "./Sidebar.css";
import { ARTICLE_CATEGORIES, ARTICLE_SOURCES } from "../../constants";

interface SidebarProps {
  selectedCategory: string;
  selectedSource: string;
  onSelectCategory: (category: string) => void;
  onSelectSource: (source: string) => void;
  isOpen: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  selectedCategory,
  selectedSource,
  onSelectCategory,
  onSelectSource,
  isOpen,
  onClose,
}) => {
  const categories = ["All", ...ARTICLE_CATEGORIES];
  const sources = ["All", ...ARTICLE_SOURCES];

  return (
    <nav className={`sidebar ${isOpen ? "open" : ""}`}>
      <button className="close-button" onClick={onClose}>
        &times;
      </button>
      <h1 className="sidebar-title">News</h1>

      <h2 className="sidebar-subtitle">Categories</h2>
      <ul className="sidebar-list">
        {categories.map((category) => (
          <li
            key={category}
            className={`sidebar-item ${
              selectedCategory === category ? "active" : ""
            }`}
            onClick={() => onSelectCategory(category)}
          >
            {category}
          </li>
        ))}
      </ul>

      <h2 className="sidebar-subtitle">Sources</h2>
      <ul className="sidebar-list">
        {sources.map((source) => (
          <li
            key={source}
            className={`sidebar-item ${
              selectedSource === source ? "active" : ""
            }`}
            onClick={() => onSelectSource(source)}
          >
            {source.replace(/_/g, " ")}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Sidebar;
